import {
    AbstractSelectEditControlComponent,
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {Component, Injector} from "@angular/core";
import {AccountInvoiceSearchModel} from "../account-invoice-search.model";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {AccountInvoiceSearchPageComponent} from "../account-invoice-search-page/account-invoice-search-page.component";
import {debounceTime, distinctUntilChanged, Subject} from "rxjs";

@Component({
    selector: "wbo-account-invoice-autocomplete-edit-control",
    templateUrl: "./account-invoice-autocomplete-edit-control.component.html",
    providers: [
        registerSelectEditControl(AccountInvoiceAutocompleteEditControl),
        provideSearchModel(AccountInvoiceSearchModel)
    ]
})
export class AccountInvoiceAutocompleteEditControl extends AbstractSelectEditControlComponent<AccountInvoiceSearchModel> {
    accountNo: string;
    accountName: string;

    private localFilterWatcher: Subject<string> = new Subject<string>();

    constructor(model: AccountInvoiceSearchModel, injector: Injector) {
        super(model, injector, "RECEIPTNO", "RECEIPTNO");
        this.extendedSearchComponent = AccountInvoiceSearchPageComponent;

        this.localFilterWatcher.pipe(
            debounceTime(400),
            distinctUntilChanged()
        ).subscribe(searchValue => {
            this.model.filter["RECEIPTNO"] = searchValue;
            this.model.search().subscribe(() => {
                this.data = this.model.data;
            });
        });
    }

    filterResults(filter: string): void {
        this.localFilterWatcher.next(filter);
    }

    selected(entity): void {
        if (entity) {
            this.value = entity[this.valueField];
        } else {
            this.value = undefined;
        }
        this.onSelect.emit(entity);
    }
}
